// removed by extract-text-webpack-plugin
module.exports = {"Container":"_3LygC","MobileHeader":"_tSMGA","Wrapper":"_2NC9T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Addons.scss
// module id = 540
// module chunks = 0